<template>
  <section class="!g-pt-12 !g-pb-10">
    <div class="gp-2-column">
      <div class="gp-left-column">
        <div class="g-mb-5" v-for="(productCategory, categoryName) in sortedProducts" :key="categoryName">
          <div class="g-flex g-justify-between g-border-b-4 g-text-xl g-mb-3 g-mt-6 g-pb-1">
            <p class="g-font-bold g-capitalize">{{ categoryName }}</p>
            <p>{{ getCategoryTotal(productCategory, categoryName) | formatPrice }} EUR</p>
          </div>
          <div class="g-flex g-justify-between" v-for="variation of productCategory" :key="variation.id">
            <div class="g-w-3/4 g-mb-3">
              <div v-if="variation.texts" class="g-flex">
                <p class="g-font-bold g-mr-2 g-whitespace-nowrap">
                  {{ basket[variation.id] }}
                  <span v-if="categoryName === 'dachbahn'">m</span>
                  <span v-else>x</span>
                </p>
                <p>
                  <span v-if="categoryName === 'dachrand'">{{ getAttributeValue(variation, "Dachrandprofil") }}</span>
                  <span v-else>{{ variation.texts[0].name1 }}</span>
                  <span v-if="categoryName === 'dachbahn'" class="g-mr-2">
                    | {{ Number(getAttributeValue(variation, "Bahnbreite ElastoTop")) | formatPrice }} m
                  </span>
                </p>
              </div>
            </div>

            <div class="g-w-1/4 g-ml-auto g-text-right">
              <p v-if="categoryName === 'dachbahn'" class="g-font-bold">{{ getDachbahnPrice(variation) | formatPrice }} EUR</p>
              <p v-else class="g-font-bold">{{ getPrice(variation) | formatPrice }} EUR</p>
            </div>
          </div>
        </div>
      </div>

      <div class="gp-right-column">
        <div class="g-mb-3 g-mt-6 g-pb-6 g-border-b-4">
          <p class="g-font-bold g-text-xl">Zusätzliches Zubehör</p>
          <p>{{ texts['8.1'] }}</p>
        </div>

        <div class="g-flex g-justify-between g-text-2xl g-mb-3 g-mt-6 g-pb-1">
          <p class="g-font-bold">Insgesamt</p>
          <p>{{ basketTotal | formatPrice }} EUR*</p>
        </div>

        <p v-if="buttonError" class="g-font-bold g-bg-yellow-400 g-mb-2 g-px-5 g-py-3">
          Es scheint ein Problem mit dem Dachbahnplaner zu geben. <br />Bitte nehmen Sie Kontakt mit uns auf.
        </p>
        <button
          class="g-w-full g-bg-gray-800 g-px-6 g-py-2 g-text-lg g-font-bold g-text-white"
          :class="{
            '!g-bg-green-500': buttonSuccess,
            'g-bg-gray-300': buttonLoading,
            'g-bg-gray-400 g-cursor-not-allowed': buttonDisabled,
            '!g-bg-red-600': buttonError,
          }"
          @click="addToBasket"
          :disabled="buttonDisabled"
        >
          <span v-if="!buttonSuccess && !buttonLoading && !buttonError">In den Warenkorb</span>
          <span v-if="buttonLoading">Wird hinzugefügt</span>
          <span v-if="buttonSuccess">Produkt ist im Warenkorb</span>
          <span v-if="buttonError">Es ist ein Fehler aufgetreten</span>
        </button>
        <p class="g-text-sm g-text-grey-600 g-mt-2">* inkl. ges. MwSt. zzgl. Versandkosten</p>
      </div>
    </div>
  </section>
</template>

<script>
import { getAttributeValue, getPrice } from "../plentyHelpers.js";

export default {
  name: "Warenkorb",

  data() {
    return {
      buttonLoading: false,
      buttonSuccess: false,
      buttonDisabled: false,
      buttonError: false,
    };
  },

  computed: {
    sortedProducts() {
      let products = {};
      let basketIds = Object.keys(this.$store.state.zusammenstellung.basket).map((key) => Number(key));

      products.dachbahn = this.$store.getters.dachbahnVariations.filter((variation) => basketIds.includes(variation?.id));

      let glueVariations = [...this.$store.getters.glueVariations];
      let addOnGlueVariation = this.$store.getters.variations.find((variation) => variation.itemId == 2303);
      glueVariations = [...glueVariations, addOnGlueVariation];

      products.kleber = glueVariations.filter((variation) => basketIds.includes(variation?.id));
      products.dachrand = this.$store.getters.dachrandVariations.filter((variation) => basketIds.includes(variation?.id));

      return products;
    },

    texts() {
      return this.$store.state.inhalt.texts;
    },

    basket() {
      return this.$store.state.zusammenstellung.basket;
    },

    basketTotal() {
      let total = 0;

      for (let categoryName in this.sortedProducts) {
        total += this.getCategoryTotal(this.sortedProducts[categoryName], categoryName);
      }

      return total;
    },
  },

  methods: {
    getAttributeValue,
    getPrice,

    getDachbahnPrice(variation) {
      let squareMeterPrice = getPrice(variation);
      let bahnbreite = getAttributeValue(variation, "Bahnbreite ElastoTop");
      let quantity = this.basket[variation.id];

      return squareMeterPrice * bahnbreite * quantity;
    },

    getCategoryTotal(category, categoryName) {
      let total = 0;

      category.forEach((variation) => {
        if (categoryName === "dachbahn") return (total += this.getDachbahnPrice(variation));
        total += getPrice(variation) * this.basket[variation.id];
      });

      return total;
    },

    async addToBasket() {
      if (window.location.host === "localhost:8080") return;
      if (this.buttonDisabled) return;

      this.buttonLoading = true;
      this.buttonError = false;
      let variationIds = Object.keys(this.basket);
      let itemsToAdd = variationIds.length;
      let itemAdded = 0;

      let requests = [];

      for (const variationId of variationIds) {
        let variation = this.$store.getters.variations.find((variation) => variation.id == variationId);
        if (!variation) continue;

        console.log({ variationId, variation, quantity: this.basket[variationId], variationIds, itemsToAdd, itemAdded });

        let basketObject = this.createBasketObject(variation, this.basket[variationId]);
        console.log(`${itemAdded}/${itemsToAdd}`, { basketObject });

        requests.push(
          window.vueApp.$store.dispatch("addBasketItem", basketObject).then(
            (response) => {
              itemAdded++;
              console.log(`${itemAdded}/${itemsToAdd} items added to basket`);
            },
            (error) => {
              if (error.data) console.log({ error: error.data });
              this.buttonError = true;
            }
          )
        );
      }

      await Promise.all(requests);

      this.buttonLoading = false;
      this.flashButtonSuccess();
    },

    createBasketObject(variation, quantity) {
      let basketObject = {
        variationId: variation.id,
        quantity,
        totalOrderParamsMarkup: 0,
        template: "Ceres::Basket.Basket",
        templateType: "item",
      };

      // If is dachbahn variation, change quantity and add additional params
      console.log("Before Bahnbreite", basketObject);
      let bahnbreite = getAttributeValue(variation, "Bahnbreite ElastoTop");
      if (bahnbreite) {
        basketObject.basketItemOrderParams = [
          {
            propertyId: 6,
            type: "float",
            name: "Länge in Meter",
            value: quantity,
          },
        ];

        // Set number of square meters as quantity instead of number of meters
        basketObject.quantity = quantity * bahnbreite;
      }

      return basketObject;
    },

    flashButtonSuccess() {
      this.buttonSuccess = true;

      setTimeout(() => {
        this.buttonSuccess = false;
      }, 5000);
    },
  },

  props: ["position"],
};
</script>

<style></style>
